import Lottie from 'lottie-react'

import beautifulLoader from '../../assets/4-dots-loader.json'

const LoadingAnimeSpinner = () => {
    return (
        <div className='d-flex align-items-center justify-content-center w-100 h-100'>
            <div style={{height: 350}}>
                <Lottie
                    animationData={beautifulLoader}
                    loop={true}
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                    }}
                />
            </div>
        </div>
    )
}

const Dotpulse = ({width, height}: {width?: number, height?: number}) => {
    return (
        <div style={{
            width: width || '100%',
            height: height || '100%',
            overflow: 'hidden',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            <div style={{transform: 'scale(4)'}}>
                <Lottie
                    animationData={beautifulLoader}
                    style={{width: '100%', height: '100%'}}
                    autoplay={true}
                    loop={true}
                />
            </div>
        </div>
    )
}

export {
    LoadingAnimeSpinner,
    Dotpulse
}